var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('custom-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"loading":_vm.loading},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}},{key:"duties",fn:function(ref){
var item = ref.item;
return [_vm._t("duties",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }